const Products=()=>{
  return (
    <div style={{display:'flex',width:'100%'}}>
      <div style={{display:'flex',height:window.innerHeight*window.barSize}}>
        ÜRÜNLER
      </div>
      <div style={{display:'flex',width:'100%',height:window.innerHeight*(1-window.barSize*2),justifyContent:'space-evenly'}}>
        <div style={{display:'flex'}}>
          <img
          style={{display:'flex',width:'100%',maxWidth:700,aspectRatio:2,objectFit:'cover',maxHeight:window.innerHeight*0.5}}
          src={require('../../Assets/CoffeeAmericano.jpg')}/>
          <div style={{}}>
            Caffè Americano
          </div>
          <div style={{width:'95%',maxWidth:700,fontSize:13,fontFamily:'Helvetica',color:'silver'}}>
            Kelime anlamı ile Amerikan kahvesi. Sıcak su ekleyerek espresso kaynatmak yöntemi ile hazırlanan kahve çeşidi. Americano'nun sertliği eklenen espresso ve suyun miktarına göre değişir.
          </div>
        </div>
        <div style={{}}>
          <button style={{padding:10}}>
            Sipariş ver
          </button>
          <div style={{padding:10,flexDirection:'row'}}>
            <div style={{fontSize:17}}>
              79.90₺
            </div>
            <div style={{color:'silver',fontSize:17,textDecorationLine: 'line-through',alignSelf:'flex-start'}}>
              99.90₺
            </div>
          </div>
        </div>
      </div>
      <div style={{display:'flex',width:'100%',height:window.innerHeight*(1-window.barSize*2),justifyContent:'space-evenly'}}>
        <div style={{display:'flex'}}>
          <img
          style={{display:'flex',width:'100%',maxWidth:700,aspectRatio:2,objectFit:'cover',maxHeight:window.innerHeight*0.5}}
          src={require('../../Assets/Latte.jpg')}/>
          <div style={{}}>
            Latte
          </div>
          <div style={{width:'95%',maxWidth:700,fontSize:13,fontFamily:'Helvetica',color:'silver'}}>
            İtalyancada süt anlamına gelmektedir. "Latte" ile "Latte Macchiato" yapılışları farklıdır. Espresso, kupaya eklenir üstüne süt ve süt kreması eklenir. Genellikle ince ve uzun bardakta servis edilir. İsteğe göre üzerine süt köpüğü ve tatlı krema eklenir.
          </div>
        </div>
        <div style={{}}>
          <button style={{padding:10}}>
            Sipariş ver
          </button>
          <div style={{padding:10,flexDirection:'row'}}>
            <div style={{fontSize:17}}>
              69.90₺
            </div>
            <div style={{color:'silver',fontSize:17,textDecorationLine: 'line-through',alignSelf:'flex-start'}}>
              89.90₺
            </div>
          </div>
        </div>
      </div>
      <div style={{display:'flex',width:'100%',height:window.innerHeight*(1-window.barSize*2),justifyContent:'space-evenly'}}>
        <div style={{display:'flex'}}>
          <img
          style={{display:'flex',width:'100%',maxWidth:700,aspectRatio:2,objectFit:'cover',maxHeight:window.innerHeight*0.5}}
          src={require('../../Assets/Cappuccino.png')}/>
          <div style={{}}>
            Cappuccino
          </div>
          <div style={{width:'95%',maxWidth:700,fontSize:13,fontFamily:'Helvetica',color:'silver'}}>
            İtalyan yapımı bir kahve türüdür. Espresso ve sıcak sütün kaynatılmasıyla meydana gelir.
           </div>
        </div>
        <div style={{}}>
          <button style={{padding:10}}>
            Sipariş ver
          </button>
          <div style={{padding:10,flexDirection:'row'}}>
            <div style={{fontSize:17}}>
              59.90₺
            </div>
            <div style={{color:'silver',fontSize:17,textDecorationLine: 'line-through',alignSelf:'flex-start'}}>
              89.90₺
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Products;
